/* eslint-disable no-bitwise */
import { ATTACHMENT_ENDPOINTS } from 'SharedDir/backend/endpoints/attachments';
import { isEmptyOrNullString, random } from '@packages/toolbox';
import { ref } from 'vue';

function hashStringToNumber(input: string, startIndex: number = 0, length?: number): number {
  let hash = 0;

  if (input.length === 0) return hash;

  let endIndex = length !== undefined ? startIndex + length : input.length;
  endIndex = Math.min(endIndex, input.length);

  for (let i = startIndex; i < endIndex; i++) {
    const charCode = input.charCodeAt(i);

    hash += charCode;
  }

  hash |= 0;
  return Math.abs(hash);
}

export function useImageFallback(imageAvatar: string = '') {
  const imageFallback = ref(false);

  function imageNotLoading() {
    imageFallback.value = true;
  }

  const imageFallbackArr = [
    'images/fallback/fallback-1.png',
    'images/fallback/fallback-2.png',
    'images/fallback/fallback-3.png',
    'images/fallback/fallback-4.png',
    'images/fallback/fallback-5.png',
    'images/fallback/fallback-6.png',
    'images/fallback/fallback-7.png',
    'images/fallback/fallback-8.png',
    'images/fallback/fallback-9.png',
    'images/fallback/fallback-10.png',
    'images/fallback/fallback-11.png',
    'images/fallback/fallback-12.png',
  ];

  const imageFallbackAvatar = imageAvatar || 'images/fallback/avatar.svg';

  function getImage(imageId: string, entityId?: number | null) {
    if (imageId && !isEmptyOrNullString(imageId) && !imageFallback.value) {
      return ATTACHMENT_ENDPOINTS.GET(imageId).url;
    }

    let index = 0;

    // Возможность сохранения постоянного placeholder для одного и того же объекта
    if (entityId) {
      const imageIdNumber =
        typeof entityId === 'number' ? entityId : hashStringToNumber(`${entityId}`, 0, 4);
      index = imageIdNumber % imageFallbackArr.length;

      return imageFallbackArr[index];
    }

    index = random([0, imageFallbackArr.length - 1]);
    return imageFallbackArr[index];
  }

  return { imageFallback, imageFallbackAvatar, getImage, imageNotLoading };
}
